import React from "react";
import { useTelegramNotifications } from '../../hooks/useTelegramNotifications';
import './NotificationsTab.css';

export default function NotificationsTab({ showSavedToast }) {
  const { enabled, loading, toggle } = useTelegramNotifications({ showSavedToast });

  return (
    <div className="profile-content">
      <div className="profile-header">
        <h1>Notifications</h1>
        <p className="profile-header-subtitle">Choose what you get notified about.</p>
      </div>

      <div className="profile-main-content">
        <div className="profile-fields-section">
          <div className="settings-section">
            <h2 className="settings-section-title">Telegram</h2>
            <div className="profile-field">
              <div className="notifications-toggle-row">
                <div className="notifications-toggle-text">
                  <h3>Telegram notifications</h3>
                  <p>
                    Forwards new chat messages from your students into your connected
                    Telegram. Turning this off only stops that forwarding — the chat
                    inside NOVAS keeps working as usual.
                  </p>
                </div>
                <label className="notifications-switch">
                  <input
                    type="checkbox"
                    checked={enabled}
                    disabled={loading}
                    onChange={toggle}
                  />
                  <span className="notifications-switch-slider" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
